import React, { useState } from "react";
import AdminService from "src/services/admin.services"; // Adjust if needed

const adminService = new AdminService();

const SUPERADMIN_EMAIL = "peakd@gmail.com";
const SUPERADMIN_PASSWORD = "peakdelivery";

const DeleteAdmin: React.FC = () => {
  const [id, setId] = useState("");
  const [superadminEmail, setSuperadminEmail] = useState("");
  const [superadminPassword, setSuperadminPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDelete = async () => {
    if (
      superadminEmail !== SUPERADMIN_EMAIL ||
      superadminPassword !== SUPERADMIN_PASSWORD
    ) {
      setMessage("Invalid superadmin credentials.");
      setShowModal(true);
      return;
    }

    try {
      const response = await adminService.deleteAdmin(id);

      if (response && response.success) {
        setMessage("Admin deleted successfully!");
      } else if (response?.message) {
        setMessage(response.message);
      } else {
        setMessage("Admin deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting admin:", error);
      setMessage("Admin deleted successfully!");
    } finally {
      setShowModal(true);
      setShowConfirmation(false);
    }
  };

  const inputStyle =
    "w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-400 text-sm";

  return (
    <div className="w-full flex items-center justify-center p-4">
      <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-6 space-y-6">
        <h2 className="text-2xl font-bold text-center text-red-600">
          Delete Admin
        </h2>

        <input
          type="text"
          placeholder="Admin ID"
          value={id}
          onChange={(e) => setId(e.target.value)}
          className={inputStyle}
        />
        <input
          type="email"
          placeholder="Superadmin Email"
          value={superadminEmail}
          onChange={(e) => setSuperadminEmail(e.target.value)}
          className={inputStyle}
        />
        <input
          type="password"
          placeholder="Superadmin Password"
          value={superadminPassword}
          onChange={(e) => setSuperadminPassword(e.target.value)}
          className={inputStyle}
        />

        <button
          onClick={() => setShowConfirmation(true)}
          className="w-full bg-red-500 text-white font-medium rounded-md py-3 hover:bg-red-600 transition duration-300"
        >
          Delete Admin
        </button>
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg space-y-4">
            <p className="text-gray-800 text-center">
              Are you sure you want to delete this admin?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 rounded-md border text-gray-700"
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-md bg-red-500 text-white hover:bg-red-600"
                onClick={handleDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Message Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg space-y-4">
            <p className="text-gray-800 text-center">{message}</p>
            <button
              className="w-full bg-red-500 text-white py-2 rounded-md hover:bg-red-600"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAdmin;
